export default __webpack_public_path__ + "static/GT-America-Standard-Regular-Italic-406ae10b03a20c601b1cad318a72a902.woff";